export const PORTAL_BASE_ROUTE = "/portal/";

export const portalRoutes = {
  welcome: "/welcome",
  welcomePartner: "/welcome-partner",
  initialPasswordSetup: PORTAL_BASE_ROUTE + "initial-password-setup",
  cockpit: {
    base: PORTAL_BASE_ROUTE + "cockpit",
    idCheck: PORTAL_BASE_ROUTE + "cockpit/id-check",
    magicLogin: PORTAL_BASE_ROUTE + "cockpit/magiclogin",
  },
  manageDevice: {
    base: PORTAL_BASE_ROUTE + "manage",
    subscription: {
      base: PORTAL_BASE_ROUTE + "manage/subscription",
      display: PORTAL_BASE_ROUTE + "manage/subscription/display",
      change: PORTAL_BASE_ROUTE + "manage/subscription/change",
      checkout: PORTAL_BASE_ROUTE + "manage/subscription/change/checkout",
      automaticRenewal:
        PORTAL_BASE_ROUTE + "manage/subscription/automatic-renewal",
    },
    roaming: {
      base: PORTAL_BASE_ROUTE + "manage/roaming",
      display: PORTAL_BASE_ROUTE + "manage/roaming/display",
      checkout: PORTAL_BASE_ROUTE + "manage/roaming/checkout",
      booking: PORTAL_BASE_ROUTE + "manage/roaming/booking",
    },
    voice: PORTAL_BASE_ROUTE + "manage/voice",
    watchSim: {
      base: PORTAL_BASE_ROUTE + "manage/watch-sim",
      display: PORTAL_BASE_ROUTE + "manage/watch-sim/display",
      checkout: PORTAL_BASE_ROUTE + "manage/watch-sim/checkout",
      automaticRenewal:
        PORTAL_BASE_ROUTE + "manage/watch-sim/automatic-renewal",
    },
    details: {
      base: PORTAL_BASE_ROUTE + "manage/details",
      display: PORTAL_BASE_ROUTE + "manage/details/display",
    },
    numberPorting: PORTAL_BASE_ROUTE + "manage/number-porting",
  },
  mySubscriptions: {
    base: PORTAL_BASE_ROUTE + "my-subscriptions",
    tiles: PORTAL_BASE_ROUTE + "my-subscriptions/tiles",
    list: PORTAL_BASE_ROUTE + "my-subscriptions/list",
  },
  addDevice: {
    base: PORTAL_BASE_ROUTE + "add-device",
    step1: PORTAL_BASE_ROUTE + "add-device/1",
    simSelection: PORTAL_BASE_ROUTE + "add-device/1/sim-selection",
    simVerification: PORTAL_BASE_ROUTE + "add-device/1/sim-verification",
    step2: PORTAL_BASE_ROUTE + "add-device/2",
    rateSelection: PORTAL_BASE_ROUTE + "add-device/2/rate-selection",
    step3: PORTAL_BASE_ROUTE + "add-device/3",
    numberPorting: PORTAL_BASE_ROUTE + "add-device/3/number-porting",
    step4: PORTAL_BASE_ROUTE + "add-device/4",
    checkout: PORTAL_BASE_ROUTE + "add-device/4/checkout",
    success: PORTAL_BASE_ROUTE + "add-device/success",
  },
  bulkSimActivation: PORTAL_BASE_ROUTE + "bulk-sim-activation",
  user: {
    base: PORTAL_BASE_ROUTE + "user",
    personal: PORTAL_BASE_ROUTE + "user/personal",
    payments: PORTAL_BASE_ROUTE + "user/payments",
    inbox: PORTAL_BASE_ROUTE + "user/inbox",
    security: {
      base: PORTAL_BASE_ROUTE + "user/security",
      //###########################################################################
      //############### INITIAL SETUP INSIDE PORTAL
      initialSetup: PORTAL_BASE_ROUTE + "user/security/initial-setup",
      initialSmsSetup: PORTAL_BASE_ROUTE + "user/security/initial-sms-setup",
      initialSmsConfirm:
        PORTAL_BASE_ROUTE + "user/security/initial-sms-confirm",
      initialAppSetup: PORTAL_BASE_ROUTE + "user/security/initial-app-setup",
      //###########################################################################
      //
      //###########################################################################
      //############### CHANGE OF EXISTING 2FA
      change2faApp: PORTAL_BASE_ROUTE + "user/security/change-app",
      change2faSms: PORTAL_BASE_ROUTE + "user/security/change-sms",
      //############### CHANGE TO SMS
      setup2faSms: PORTAL_BASE_ROUTE + "user/security/setup-sms",
      verify2faSms: PORTAL_BASE_ROUTE + "user/security/verify-sms",
      //############### CHANGE SMS NUMBER
      verify2faNumberChange:
        PORTAL_BASE_ROUTE + "user/security/verify-number-change",
      //############### CHANGE TO APP (ONLY 1 SCREEN SINCE CONFIRM + VERIFY IS SHOWN)
      setup2faApp: PORTAL_BASE_ROUTE + "user/security/setup-app",
      //############### CONFIRMATIONS
      confirmBackupCodeReception:
        PORTAL_BASE_ROUTE + "user/security/confirm-backup-codes",
      confirmStandard: PORTAL_BASE_ROUTE + "user/security/confirm-standard",
      //###########################################################################
    },
  },
  documents: {
    base: PORTAL_BASE_ROUTE + "documents",
    bills: PORTAL_BASE_ROUTE + "documents/bills",
    itemizedBills: PORTAL_BASE_ROUTE + "documents/itemized-bills",
    payments: PORTAL_BASE_ROUTE + "documents/payments",
    bulkMove: PORTAL_BASE_ROUTE + "documents/payments/bulk-move",
  },
  friendsWithBenefits: {
    base: PORTAL_BASE_ROUTE + "friends-with-benefits",
    createGroup: PORTAL_BASE_ROUTE + "friends-with-benefits/create-group",
    groupOverview: PORTAL_BASE_ROUTE + "friends-with-benefits/group",
  },
  personalDataOnboarding: PORTAL_BASE_ROUTE + "personal-data-onboarding",
  notFound: PORTAL_BASE_ROUTE + "*",
} as const;
